import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=2a9b16f2&"
import script from "./guide.vue?vue&type=script&lang=js&"
export * from "./guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports